import { render, staticRenderFns } from "./IconArrowLeftSm.vue?vue&type=template&id=2ca99758&"
import script from "./IconArrowLeftSm.vue?vue&type=script&lang=js&"
export * from "./IconArrowLeftSm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca99758')) {
      api.createRecord('2ca99758', component.options)
    } else {
      api.reload('2ca99758', component.options)
    }
    module.hot.accept("./IconArrowLeftSm.vue?vue&type=template&id=2ca99758&", function () {
      api.rerender('2ca99758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconArrowLeftSm.vue"
export default component.exports